import numeral from 'numeral';

export const celebrityKeys = [
    {
        renderCell: ({ data }) => numeral(data).format('0%'),
        key: 'relevancy',
        label: 'relevancy',
        className: 'change up',
    },
    {
        renderCell: ({ item }) => {
            let type = item.type.replace(/_/g, ' ');
            type = type[0].toUpperCase() + type.slice(1).toLowerCase();

            return (
                <div className="col-12 no-wrap ms-3">
                    <a
                        href={
                            `/domains/${window.info.id}/entities/entity?entities:in=` +
                            encodeURIComponent(item.name)
                        }
                    >
                        {item.name} ({type})
                    </a>
                </div>
            );
        },
        label: 'Celebrity',
        type: 'label',
    },
    {
        key: 'rank',
        label: 'Rank',
        bar: true,
        renderCell: ({ item, allData }) => {
            let imp = item.impressions / allData.reduce((e, f) => e + f.impressions, 0);
            let ctr = item.ctr / (allData.reduce((e, f) => e + f.ctr, 0) / allData.length);

            return (imp + ctr) / 2;
        },
    },
];

export const ConceptsSkeys = [
    {
        renderCell: ({ data }) => numeral(data).format('0%'),
        key: 'relevancy',
        label: 'relevancy',
        className: 'change up',
    },
    {
        renderCell: ({ item }) => {
            return (
                <div className="col-12 no-wrap ms-3">
                    <a
                        href={
                            `/domains/${window.info.id}/entities/entity?entities:in=` +
                            encodeURIComponent(item.name)
                        }
                    >
                        {item.name}
                    </a>
                </div>
            );
        },
        label: 'Category',
        type: 'label',
        classes: 'col-10 ',
    },
    {
        key: 'rank',
        label: 'Rank',
        bar: true,
        renderCell: ({ item, allData }) => {
            let imp = item.impressions / allData.reduce((e, f) => e + f.impressions, 0);
            let ctr = item.ctr / (allData.reduce((e, f) => e + f.ctr, 0) / allData.length);

            return (imp + ctr) / 2;
        },
    },
];
